import { render, staticRenderFns } from "./NewsListPage.vue?vue&type=template&id=4e08febe"
import script from "./NewsListPage.vue?vue&type=script&lang=js"
export * from "./NewsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports